import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useHostLabels(propertyIds: string[]) {
  const key = [...propertyIds].sort().join(",");

  return useQuery({
    queryKey: ["host-labels", key],
    queryFn: async (): Promise<Record<string, string>> => {
      if (propertyIds.length === 0) return {};
      const { data, error } = await supabase.rpc("get_host_labels_for_properties", {
        p_ids: propertyIds,
      });
      if (error) {
        console.error("[useHostLabels]", error);
        return {};
      }
      const out: Record<string, string> = {};
      for (const row of data ?? []) {
        const id = (row as { property_id?: string }).property_id;
        const label = (row as { host_label?: string }).host_label;
        if (id && label) out[id] = label;
      }
      return out;
    },
    enabled: propertyIds.length > 0,
    staleTime: 1000 * 60 * 5,
  });
}
